export const computeFreeAvailableLogsSize = (max_log_size_unit, insert_reserved_log_size_unit, insert_reserved_log_size, max_log_size) => {
  let multiplier = insert_reserved_log_size_unit === "MB" ? 1000 : 1
  let multiplierMaxLogSize = max_log_size_unit === 'MB' ? 1000 : 1

  let availableSizeInGB = (max_log_size * multiplier) - (insert_reserved_log_size * multiplierMaxLogSize)
  let computedFreeSize = (availableSizeInGB / multiplier) + ' ' + max_log_size_unit

  return availableSizeInGB / multiplier < 0 ? 0 : computedFreeSize
}
